import React from "react";

const LeftArrow = (props: any) => {
  return (
    <svg
      width="25"
      height="26"
      viewBox="0 0 25 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M8.81353 12.2784L14.9986 6.09335C15.2047 5.88719 15.4109 5.7841 15.7201 5.7841C16.0294 5.7841 16.2356 5.88719 16.4417 6.09335C16.8541 6.50569 16.8541 7.12419 16.4417 7.53652L10.9783 13L16.4417 18.4634C16.8541 18.8757 16.8541 19.4942 16.4417 19.9066C16.0294 20.3189 15.4109 20.3189 14.9986 19.9066L8.81353 13.7215C8.4012 13.3092 8.4012 12.6907 8.81353 12.2784Z"
        fill="currentColor"
      />
      <path
        d="M8.81353 12.2784L14.9986 6.09335C15.2047 5.88719 15.4109 5.7841 15.7201 5.7841C16.0294 5.7841 16.2356 5.88719 16.4417 6.09335C16.8541 6.50569 16.8541 7.12419 16.4417 7.53652L10.9783 13L16.4417 18.4634C16.8541 18.8757 16.8541 19.4942 16.4417 19.9066C16.0294 20.3189 15.4109 20.3189 14.9986 19.9066L8.81353 13.7215C8.4012 13.3092 8.4012 12.6907 8.81353 12.2784Z"
        fill="currentColor"
      />
    </svg>
  );
};

export default LeftArrow;
